module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eJ1AE"))).then(() => parcelRequire('1iHdE'));